/**
 * EU-27 Länder-Labels (Deutsch) für das Mollie-Checkout-Formular (NT-MOLLIE-CHECKOUT-01).
 *
 * Duplikat der Backend-Liste (EU_COUNTRY_CODES in modules/shop/checkout.constants.ts)
 * bewusst 1:1 im Frontend gehalten — analog zum bestehenden Muster bei
 * BUG_REPORT_DISCORD_TAGS (kein Shared-Import für rein deskriptive Listen).
 */
export const EU_COUNTRY_LABELS: Record<string, string> = {
  DE: 'Deutschland',
  AT: 'Österreich',
  BE: 'Belgien',
  BG: 'Bulgarien',
  HR: 'Kroatien',
  CY: 'Zypern',
  CZ: 'Tschechien',
  DK: 'Dänemark',
  EE: 'Estland',
  FI: 'Finnland',
  FR: 'Frankreich',
  GR: 'Griechenland',
  HU: 'Ungarn',
  IE: 'Irland',
  IT: 'Italien',
  LV: 'Lettland',
  LT: 'Litauen',
  LU: 'Luxemburg',
  MT: 'Malta',
  NL: 'Niederlande',
  PL: 'Polen',
  PT: 'Portugal',
  RO: 'Rumänien',
  SK: 'Slowakei',
  SI: 'Slowenien',
  ES: 'Spanien',
  SE: 'Schweden',
};

export const EU_COUNTRY_CODES = Object.keys(EU_COUNTRY_LABELS);
